// PLACEHOLDER testimonials — replace with real client reviews (name, role, company, rating 1-5, quote, service slug)
export const testimonials = [
  {
    id: 1,
    name: 'Maria Gonzalez',
    role: 'Owner',
    company: 'Casa Verde Restaurant, Fayetteville',
    rating: 5,
    quote: 'Within three months our Google ranking jumped to the first page and weekend reservations doubled. The team explains everything in plain English.',
    service: 'seo-optimization',
  },
  {
    id: 2,
    name: 'James Whitaker',
    role: 'Founder',
    company: 'Ozark Outdoor Supply',
    rating: 5,
    quote: 'Our new website loads fast, looks incredible on phones, and the quote calculator alone paid for itself in the first month.',
    service: 'web-design-development',
  },
  {
    id: 3,
    name: 'Dr. Priya Nair',
    role: 'Practice Manager',
    company: 'NWA Family Dental',
    rating: 5,
    quote: 'The AI receptionist and chatbot answer patient questions after hours, so we stopped missing new-patient calls. Setup was painless.',
    service: 'ai-business-solutions',
  },
  {
    id: 4,
    name: 'Tyler Brooks',
    role: 'Marketing Director',
    company: 'Brooks Realty Group',
    rating: 4,
    quote: 'PPC cost-per-lead dropped 38% in two months. Transparent reporting and no surprises on the invoice.',
    service: 'ppc-advertising',
  },
  {
    id: 5,
    name: 'Angela Reyes',
    role: 'Co-owner',
    company: 'Sunrise Fitness Studio',
    rating: 5,
    quote: 'Our social media finally feels consistent and on-brand. Followers are up 3x and classes are filling from Instagram alone.',
    service: 'social-media-marketing',
  },
  {
    id: 6,
    name: 'Marcus Lee',
    role: 'CEO',
    company: 'Lee Logistics',
    rating: 5,
    quote: 'They rebuilt our brand from the logo up and the new identity won us two enterprise contracts. Worth every dollar.',
    service: 'brand-strategy-design',
  },
];
